export default {
  e: {
    slug: 'the-rock',
    profile: 'Rock',
    blurb: 'Devoted, Compassionate, & Strong',
    description: 'She’s always there for you when you need her the most. When you’re weak, she’s strong. When you’re down, she’s up. She’s your rock.',
    products: [
      {
        title: 'Because She’s Devoted',
        location: 'top',
        name: 'Round Milgrain Bezel Pendant',
        color: 'Rose Gold',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234820520;432715645;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234820520;dc_trk_aid=432715645;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'necklace'
      },
      {
        title: 'Because She’s Compassionate',
        name: 'Three Stone Bezel Studs',
        color: 'Rose Gold',
        location: 'right',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234820847;432715861;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234820847;dc_trk_aid=432715861;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'earring'
      },
      {
        title: 'Because She’s Strong',
        name: 'Diamond Stackable Ring',
        color: 'White Gold',
        location: 'bottom',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234819677;432715648;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234819677;dc_trk_aid=432715648;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'ring'
      }
    ]
  },
  f: {
    slug: 'the-adventurer',
    profile: 'Adventurer',
    blurb: 'Fearless, Energetic, & Bold',
    description: 'She encourages you to visit new places, try new things, meet new people. She’s open-minded and big-hearted, accepting and adaptable. She always manages to see the good in you, in strangers, in the world-at-large.',
    products: [
      {
        title: 'Because She’s Fearless',
        name: 'Round Diamond Necklace',
        color: 'Rose Gold',
        location: 'top',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234819686;432715855;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234819686;dc_trk_aid=432715855;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'necklace'
      },
      {
        title: 'Because She’s Energetic',
        name: 'Three Stone Bezel Studs',
        color: 'White Gold',
        location: 'right',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234818759;432627108;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234818759;dc_trk_aid=432627108;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'earring'
      },
      {
        title: 'Because She’s Bold',
        name: 'Classic Bezel Stackable Ring',
        color: 'White Gold',
        location: 'bottom',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234819689;432627105;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234819689;dc_trk_aid=432627105;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'ring'
      }
    ]
  },
  g: {
    slug: 'the-nurturer',
    profile: 'Nurturer',
    blurb: 'Loyal, Gentle, & Compassionate',
    description: 'She takes care of everyone around her—including you. She’s not happy unless the people she loves are happy. She’s loyal, but not blindly so. And don’t get it twisted: she may be sweet, but she’s also the strongest person you’ve ever met.',
    products: [
      {
        title: 'Because She’s Loyal',
        name: 'Oval Diamond Necklace',
        color: 'Yellow Gold',
        location: 'top',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234820517;432715636;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234820517;dc_trk_aid=432715636;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'necklace'
      },
      {
        title: 'Because She’s Compassionate',
        name: 'Beaded Stud Earrings',
        color: 'White Gold',
        location: 'right',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;235088607;432715642;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.235088607;dc_trk_aid=432715642;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'earring'
      },
      {
        title: 'Because She’s Gentle',
        name: 'Classic Bezel Stackable Ring',
        color: 'White Gold',
        location: 'bottom',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;235086717;432715639;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.235086717;dc_trk_aid=432715639;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'ring'
      }
    ]
  },
  h: {
    slug: 'the-aesthete',
    profile: 'Aesthete',
    blurb: 'Intuitive, Discerning, & Creative',
    description: 'She sees beauty in every little thing. She’s incredibly perceptive and sensitive to people’s needs. And where most people zig, she zags: her creativity—the way she approaches a problem—never fails to astound you.',
    products: [
      {
        title: 'Because She’s Discerning',
        name: 'Round Beaded Pendant',
        color: 'White Gold',
        location: 'top',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234820850;432627111;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234820850;dc_trk_aid=432627111;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'necklace'
      },
      {
        title: 'Because She’s Creative',
        name: 'Beaded Stud Earrings',
        color: 'Yellow Gold',
        location: 'right',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;235085541;432627117;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.235085541;dc_trk_aid=432627117;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'earring'
      },
      {
        title: 'Because She’s Intuitive',
        name: 'Beaded Diamond Ring',
        color: 'White Gold',
        location: 'bottom',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234867196;432627114;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234867196;dc_trk_aid=432627114;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'ring'
      }
    ]
  },
  i: {
    slug: 'the-butterfly',
    profile: 'Butterfly',
    blurb: 'Outgoing, Magnetic, & Playful',
    description: 'You’re not ashamed to admit it: she’s the popular one. Her friends—and your friends—love her almost as much as you do. She’s funny, outgoing and always makes sure everyone around her is enjoying themselves.',
    products: [
      {
        title: 'Because She’s Outgoing',
        name: 'Oval Diamond Necklace',
        color: 'White Gold',
        location: 'top',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234819464;432627120;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234819464;dc_trk_aid=432627120;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'necklace'
      },
      {
        title: 'Because She’s Magnetic',
        name: 'Bezel Stud Earrings',
        color: 'Rose Gold',
        location: 'right',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234818741;432715618;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234818741;dc_trk_aid=432715618;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'earring'
      },
      {
        title: 'Because She’s Playful',
        name: 'Diamond Stackable Ring',
        color: 'Rose Gold',
        location: 'bottom',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234818738;432627123;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234818738;dc_trk_aid=432627123;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'ring'
      }
    ]
  },
  j: {
    slug: 'the-visionary',
    profile: 'Visionary',
    blurb: 'Brilliant, Charismatic, & Playful',
    description: 'She see things you tend to miss. She’s not afraid to speak her mind, or argue a point she’s passionate about. If she’s occasionally critical, it’s only because she wants you to be the best person you can be.',
    products: [
      {
        title: 'Because She’s Brilliant',
        name: 'Pear Diamond Necklace',
        color: 'Yellow Gold',
        location: 'top',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234867190;432715864;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234867190;dc_trk_aid=432715864;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'necklace'
      },
      {
        title: 'Because She’s Inspirational',
        name: 'Braided Hoop Earrings',
        color: 'White Gold',
        location: 'right',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234866878;432715870;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234866878;dc_trk_aid=432715870;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'earring'
      },
      {
        title: 'Because She’s Charismatic',
        name: 'Delicate Diamond Ring',
        color: 'Yellow Gold',
        location: 'bottom',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234819680;432715867;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234819680;dc_trk_aid=432715867;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'ring'
      }
    ]
  },
  k: {
    slug: 'the-lodestar',
    profile: 'Lodestar',
    blurb: 'Ambitious, Bold, & Persevering',
    description: 'She’s a natural born leader. She’s perennially prepared—oftentimes so you don’t have to be. When things don’t go her way, and they rarely don’t, that’s okay: she’s got a back-up plan.',
    products: [
      {
        title: 'Because She’s Ambitious',
        name: 'Emerald Diamond Necklace',
        color: 'Yellow Gold',
        location: 'top',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234820841;432715621;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234820841;dc_trk_aid=432715621;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'necklace'
      },
      {
        title: 'Because She’s Persevering',
        name: 'Braided Hoop Earrings',
        color: 'Yellow Gold',
        location: 'right',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234867175;432715633;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234867175;dc_trk_aid=432715633;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'earring'
      },
      {
        title: 'Because She’s Bold',
        name: 'Milgrain Bezel Ring',
        color: 'White Gold',
        location: 'bottom',
        url: 'https://t.mookie1.com/t/v1/clk?migAgencyId=458&migSource=adsrv2&migTrackDataExt=3083108;234818747;432715624;109086899&migTrackFmtExt=client;io;ad;crtv&migUnencodedDest=https://ad.doubleclick.net/ddm/trackclk/N3867.128268.URBANDADDY/B21881544.234818747;dc_trk_aid=432715624;dc_trk_cid=109086899;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=',
        type: 'ring'
      }
    ]
  },

  more: {
    eyebrow: "FOR ALL THAT SHE IS",
    title: "The Forevermark Tribute™ Collection",
    dek: "Discover the Forevermark Tribute™ Collection, celebrating the unique and brilliant woman who wears it.",
    details: [
      {
        eyebrow: "WHAT TO GET HER",
        title: "The Ultimate Gift To Give",
        description: "The Forevermark Tribute™ Collection is the perfect gift for the woman you adore this holiday season.  Each diamond jewelry piece can be worn stacked or layered to reflect her individual style and character, paying tribute to the many qualities that make her the incredible woman she is.",
        image: "ultimateGift"
      },
      {
        eyebrow: "BEAUTIFUL AND RARE DIAMONDS",
        title: "Discover The Collection",
        description: "Forevermark diamonds are hand-selected for their beauty and rarity, and each is genuine, untreated and natural.  Of all the world’s diamonds, less than one percent is eligible to become Forevermark.  Discover more from the collection below.",
        products: [
          {
            name: "Rings",
            image: "rings",
            link: "https://www.forevermark.com/en-us/find-jewelry/?fo=false&oc=Rings%2CCollection&Style=Rings&Collection=Collection_The+Tribute%E2%84%A2+Collection"
          },
          {
            name: "Earrings",
            image: "earrings",
            link: "https://www.forevermark.com/en-us/find-jewelry/?fo=false&oc=Earrings%2CCollection&Style=Earrings&Collection=Collection_The+Tribute%E2%84%A2+Collection"
          },
          {
            name: "Pendants",
            image: "pendants",
            link: "https://www.forevermark.com/en-us/find-jewelry/?fo=false&oc=Necklaces%2CCollection&Style=Necklaces&Collection=Collection_The+Tribute%E2%84%A2+Collection"
          },
          {
            name: "Bracelets",
            image: "bracelets",
            link: "https://www.forevermark.com/en-us/find-jewelry/?fo=false&oc=Bracelets%2CCollection&Style=Bracelets&Collection=Collection_The+Tribute%E2%84%A2+Collection"
          }
        ]
      },
      {
        eyebrow: "DISCOVER FOREVERMARK",
        title: "Store Locator; Book An Appointment",
        description: "Find your nearest Authorized Forevermark Jeweler. You can also [LINK] with one of our sales ambassadors to help you find the perfect diamond for your special someone.  Click to [LINK]",
        links: [
          {
            url: 'https://www.forevermark.com/en-us/book-an-appointment/gifting/?cmpid=US_BNR_Q4Tr_%eexpid',
            text: 'book an appointment'
          },
          {
            url: 'https://www.forevermark.com/en-us/store-locator/?cid=1073751261&cmpid=US_BNR_Q4Tr_%eexpid',
            text: 'visit the Store Locator.'
          }
        ],
        image: "store"
      },
    ]
  }
}


